export const GLH_PORTALS = {
  AGENT: "MOD101",
  MEMBER: "MOD102",
  GROUP: "MOD103"
};
